module.exports = __webpack_public_path__ + "img/headbands.ff7947d2.jpg";